import { Tag, Tooltip, useTestIds } from "@homebound/beam";
import { CreateOfferingReadyPlanOptionFragment } from "src/routes/libraries/product-offerings/add-product-offering/components/4.OptionsStep.generated";
import { pluralize } from "src/utils";

type RequiredOptionsTagProps = { optionRequiredIf: CreateOfferingReadyPlanOptionFragment["optionRequiredIf"] };

export function RequiredOptionsTag(props: RequiredOptionsTagProps) {
  const { optionRequiredIf } = props;
  const tid = useTestIds({});
  if (optionRequiredIf.isEmpty) return null;
  const count = optionRequiredIf.length;
  const allCombinations = optionRequiredIf.flatMap((rpro) => rpro.targetCombinations);
  return (
    <Tooltip
      title={
        <div>
          <div>Target Combinations:</div>
          {allCombinations.map((combo) => (
            <div key={combo.id}>[{combo.options.map((o) => o.name).join("/")}]</div>
          ))}
        </div>
      }
      placement="top"
    >
      <Tag {...tid.requiredOptionsTag} text={`${count} ${pluralize(count, "required option")}`} type="update" />
    </Tooltip>
  );
}
